<template>
  <div>
    <h3
      :class="{
        'mb-5 text-xl font-black text-www-color-neutral-light lg:text-base lg:leading-[1.4rem]': true,
      }"
    >
      {{ heading }}
    </h3>
    <ul
      :class="{
        'footer-menu': true,
      }"
    >
      <li
        v-for="(linkItem, linkIndex) in link"
        :key="linkIndex"
        :class="{
          'm-0 list-none p-0': true,
        }"
      >
        <GeneralLink
          v-if="linkItem.linkTitle && linkItem.link"
          _type="generalLink"
          :text="linkItem.linkTitle"
          :link="linkItem.link"
          :class="{
            'block py-1 text-sm font-semibold leading-6 text-www-color-white no-underline ease-in hover:text-www-color-primary lg:py-8px lg:text-12px lg:leading-[20.4px]': true,
          }"
        />
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
import type { FooterColumn } from '~/sanity/types';
import GeneralLink from '../HeaderComponents/GeneralLink.vue';

defineProps<FooterColumn>();
</script>

<style lang="scss" scoped></style>
